<template>
    <div class="sellThresholdsPanel">
        <v-form ref="sellEditForm" v-model="valid">
            <div class="stp-container">
                <div class="stp-part">
                    <div class="stp-icon">
                        <font-awesome-icon :icon="icons.top" :size="iconSize" color="green"></font-awesome-icon>
                        <div class="stp-title-m" v-if="$vuetify.breakpoint.mobile">{{$t('thresholds.titleSellUp')}}</div>
                    </div>
                    <div class="stp-thresholds">
                        <div class="stp-title" v-if="!$vuetify.breakpoint.mobile">{{$t('thresholds.titleSellUp')}}</div>
                        <div class="stp-threshold">
                            <v-text-field outlined :dense="isMobile" hide-details="auto" :type="thresholdFieldType" v-model="thresholds.t800" @input="inputChanged()" @keyup="keyUp" :rules="[rules.required, rules.isPrice]" :label="$t(`thresholds.sell.t800`)">
                                <template slot="append"><font-awesome-icon :class="getThresholdColor(1)" :icon="icons.circle" size="xs"></font-awesome-icon></template>
                            </v-text-field>
                        </div>
                        <div class="stp-threshold">
                            <v-text-field outlined :dense="isMobile" hide-details="auto" :type="thresholdFieldType" v-model="thresholds.t600" @input="inputChanged()" @keyup="keyUp" :rules="[rules.isPrice]" :label="$t(`thresholds.sell.t600`)">
                                <template slot="append"><font-awesome-icon :class="getThresholdColor(2)" :icon="icons.circle" size="xs"></font-awesome-icon></template>
                            </v-text-field>
                        </div>
                    </div>
                </div>
                <div class="stp-part">
                    <div class="stp-icon">
                        <font-awesome-icon :icon="icons.bottom" :size="iconSize" color="#cc0000"></font-awesome-icon>
                        <div class="stp-title-m" v-if="$vuetify.breakpoint.mobile">{{$t('thresholds.titleSellDown')}}</div>
                    </div>
                    <div class="stp-thresholds">
                        <div class="stp-title" v-if="!$vuetify.breakpoint.mobile">{{$t('thresholds.titleSellDown')}}</div>
                        <div class="stp-threshold">
                            <v-text-field outlined :dense="isMobile" hide-details="auto" :type="thresholdFieldType" v-model="thresholds.t400" @input="inputChanged()" @keyup="keyUp" :rules="[rules.isPrice]" :label="$t(`thresholds.sell.t400`)">
                                <template slot="append"><font-awesome-icon :class="getThresholdColor(3)" :icon="icons.circle" size="xs"></font-awesome-icon></template>
                            </v-text-field>
                        </div>
                        <div class="stp-threshold">
                            <v-text-field outlined :dense="isMobile" hide-details="auto" :type="thresholdFieldType" v-model="thresholds.t200" @input="inputChanged()" @keyup="keyUp" :rules="[rules.required, rules.isPrice]" :label="$t(`thresholds.sell.t200`)">
                                <template slot="append"><font-awesome-icon :class="getThresholdColor(4)" :icon="icons.circle" size="xs"></font-awesome-icon></template>
                            </v-text-field>
                        </div>
                    </div>
                </div>
            </div>
        </v-form>
    </div>
</template>

<script>
import { faArrowToBottom, faArrowToTop, faCircle } from "@fortawesome/pro-solid-svg-icons";
import StockHtmlHelper from '../../stocks/StockHtmlHelper'
export default {
    props: ['thresholds'],
    data() {
        return {
            valid: false,
            icons: {
                bottom: faArrowToBottom,
                top: faArrowToTop,
                circle: faCircle
            },
            stockHtmlHelper: undefined,
            rules: {
                required: value => !!value || this.$t('EditorPanel.errors.required'),
                isPrice: value => {
                    const pattern = /^(\d+(?:[.,]\d{1,4})?)$/;
                    return (
                        pattern.test(value) || !value || this.$t('EditorPanel.errors.invalidPrice')
                    );
                }
            },
            thresholdFieldType: this.$vuetify.breakpoint.mobile ? 'number' : 'text'
        }
    },
    created() {
        this.stockHtmlHelper = new StockHtmlHelper();
    },
    computed: {
        iconSize() {
            return this.$vuetify.breakpoint.mobile ? '2x' : '3x';
        }
    },
    methods: {
        getThresholdColor(score) {
            return this.stockHtmlHelper.getBadgeSellColor(score);
        },
        validateForm() {
            return this.$refs.sellEditForm.validate();
        },
        isFormValid() {
            return this.valid;
        },
        resetForm() {
            this.$refs.sellEditForm.reset();
        },
        inputChanged() {
            this.$emit('inputChanged', { valid: this.isFormValid() });
        },
        keyUp(e) {
            if (e.keyCode === 13) {
                this.$emit('submitAsked', { valid: this.isFormValid() });
            }
        }
    },
    watch: {
        valid(val) {
            this.$emit('isFormValid', { valid: val });
        }
    }
}
</script>

<style scoped>
.v-card__actions {
	padding: 0 24px 20px;
}
.symbolInput input{
    text-transform: uppercase;
}
.sellThresholdsPanel{
    padding: 15px 0;
}
.stp-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.stp-part{
    flex: 1;
    display: flex;
    align-items: center;
    gap: 15px;
}
.stp-icon{
    display: flex;
    justify-content: center;
    align-items: center;
}
.stp-thresholds{
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
}
.stp-title{
    font-size: small;
    color: #333;
    width: 160px;
}

@media screen and (max-width: 768px) {
    .sellThresholdsPanel{
        padding: 0;
    }
    .stp-container {
        flex-direction: column;
    }

    .stp-part {
        flex-direction: column;
    }

    .stp-part:not(:last-of-type){
        margin-right: 0;
    }

    .stp-icon{
        justify-content: space-evenly;
        gap: 10px;
    }

    .v-text-field__details {
        display: none;
    }
}
</style>
